module.exports = __webpack_public_path__ + "fonts/fa-brands-400.1a575a41.woff";